<template>
    <div class="input-box-container mt-10px">
        <div :style="{ backgroundImage: 'url(' + img + ')' }" class="img-responsive"></div>
        <div class="d-flex vertical-center d-flex-end p-60px w-100 bg" :style="{ backgroundImage: 'url(' + img + ')' }">
            <div class="col-40">
                <GeocoderInput v-model="result" @update:modelValue="$emit('update:modelValue', result)" 
                @removeResult="(e)=>{result=null;$emit('update:modelValue', result)}"
                    class="w-100">
                </GeocoderInput>
            </div>
        </div>
    </div>
</template>
<script>
import GeocoderInput from '@/components/form/GeocoderInput.vue'
export default {
    data() {
        return {
            result: null
        };
    },
    components: {
        GeocoderInput
    },
    props: {
        img: String,
        modelValue: Object
    },
    watch: {
        modelValue(newVal) {
            this.result = newVal;
        }
    }
};
</script>
<style scoped>
.bg {
    box-sizing: border-box;
    background-size: auto 100%;
    background-repeat: no-repeat;
    min-height: 350px;
}

.input-box-container {
    position: relative;
    background-color: white;
    display: flex;
    justify-content: space-between;
    border-bottom-right-radius: 50px;
    box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
}

.input-box {
    width: 100%;
    border: 3px solid var(--Secondary-Noir, #3B3B3C);
    box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
    padding: 22px 35px;
    color: var(--text-color);
    font-family: var(--font);
    font-size: 42px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    box-sizing: border-box;
}

.input-container {
    display: flex;
    flex-direction: column;
}

.input-box-label {
    color: var(--text-color);
    font-family: var(--font);
    font-size: 42px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.distance-result {
    margin-top: 20px;
    color: var(--text-color);
    font-family: var(--font);
    font-size: 42px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.w-50 {
    width: 50%;
}

@media screen and (max-width: 900px) {
    .col-40 {
        width: 35%;
    }

    .p-60px {
        padding: 20px;
    }
}

@media screen and (max-width: 800px) {
    .input-box-container {
        flex-wrap: wrap;
    }

    .input-box-img {
        width: 100%;
    }

    .input-box-img>img {
        width: 100%;
    }

    .input-box {
        font-size: 20px;
        width: 100%;
        box-sizing: border-box;
    }

    .input-container {
        width: 100%;
    }

    .input-box-label {
        font-size: 30px;
        text-align: left !important;
        padding-bottom: 20px;
    }

    .bg {
        background-image: none !important;
        min-height: 200px !important;
    }

    .col-40 {
        width: 100%;
    }

    .img-responsive {
        display: block !important;
        box-sizing: border-box;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        min-height: 350px;
        width: 100%;
    }
}
</style>